import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const ProductById = createAsyncThunk(
  "productById/ProductById",
  async (productId, thunkAPI) => {
    console.log("productId?.variationid", productId?.variationid?._id);
    try {
      const sessionId = localStorage.getItem("uuid");
      const headers = {
        Authorization: sessionId || "",
      };
      if (productId?.variationid) {
        const response = await axios.get(
          `${endPoint.ProductSerchById}/${productId?.variationid?.productId}?variationId=${productId?.variationid?._id}`,
          { headers }
        );
        console.log("variasjhvjhbfjhf", response.data);
        return response.data;
      } else {
        const response = await axios.get(
          `${endPoint.ProductSerchById}/${productId}`,
          { headers }
        );
        console.log("product details data", response.data);
        return response.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const ProductByIdSlice = createSlice({
  name: "ProductDetailsData",
  initialState: {
    ProductDetailsData: [],
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ProductById.fulfilled, (state, action) => {
        state.ProductDetailsData = action.payload;
      })
      .addCase(ProductById.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default ProductByIdSlice.reducer;
